module.exports = __webpack_public_path__ + "static/DuosearcherMock-8bcb7087aa51d9078b96e86e24a713d3.png";